<template>
  <div class="card">
    <h2>La vetlla ha expirat</h2>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2em;

  padding: 1em;
  border-radius: $rounded-border;

  background-color: $bg-color;

  width: 80%;
  @media (max-width: 768px) {
    width: 96%;
  }
}
</style>
